<template>
  <v-col cols="12" class="py-0">
    <input-text
      v-bind="$attrs"
      label="CNAE"
      readonly
      placeholder="Buscar"
      @click="openModal"
      :value="cnae"
    >
      <template v-slot:append>
        <v-icon @click="openModal" color="primary" class="allow-click-input-disabled">search</v-icon>
      </template>
    </input-text>
    <modal-form v-model="show" :showSubmit="false" textClose="Fechar" size="lg">
      <template v-slot:title>
        Selecione o CNAE
      </template>
      <template v-slot:body>
        <core-grid mobile-breakpoint="0" modal flat ref="grid" :onRead="onRead" :refreshOption="false" :editOption="false" :deleteOption="false" :addOption="false" :schema="schema" @click="selecionar">
        </core-grid>
      </template>
    </modal-form>
  </v-col>
</template>
<script>
export default {
  props: {
    value: null,
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    cnae () {
      return this.model?.descricao ? this.model?.numero + ' - ' + this.model?.descricao : ''
    }
  },
  data () {
    return {
      cnaes: [],
      show: false,
      schema: [
        { value: 'numero', text: 'Número' },
        { value: 'descricao', text: 'Descrição' }
      ]
    }
  },
  methods: {
    selecionar: function (curr) {
      const th = this
      th.$api.UI.Confirmacao('info', 'Confirma a seleção do CNAE: ' + curr.numero + ' - ' + curr.descricao + '?', function () {
        th.$set(th, 'model', curr);
        th.$emit('emitted', curr)
        th.show = false
      })
    },
    openModal: function () {
      this.show = true
    },
    onRead: function (options) {
      options.success(this.cnaes)
    },
  },
  mounted () {
    this.$api.Dbs.Get('cnaes').then(({ success, response }) => {
      if (success) {
        this.$set(this, 'cnaes', response)
      } else {
        this.$api.UI.ShowError('Erro', "Problema ao buscar lista de CNAE's")
      }
    })
  }
}
</script>
